<div class="flex flex-col justify-around items-start">
  <div>
    <p>
      I declare that the information transmitted in DAC6 Form(s) is true and
      correct and that I am authorized to make this declaration.<br><br>
      I acknowledge that Orbitax through the use of DAC6 & MDR Reporter, is not providing
      an agent service and is not responsible for the preparation of any taxation,
      superannuation or other related documents on behalf of my business/entity. It can,
      however, submit transmissions that my business/entity chooses to make through
      Orbitax DAC6 & MDR Reporter.
    </p>
  </div>
  <div *ngIf="hasCustomFields" class="w-p-100 _container">
    <particle-transmission-form-editor-container class="w-p-100"
                                                 *ngFor="let fieldDefinition of fieldDefinitions; let i = index"
                                                 [fieldDefinition]="fieldDefinition"
                                                 (valueChanged)="onValueChanged($event)"
                                                 [item]="item"
    >

    </particle-transmission-form-editor-container>
  </div>
  <div>
    <mat-checkbox style="color: #FF8B0E" (change)="onCheck($event)" class="example-margin">Tick this box to sign and agree to the declaration</mat-checkbox>
  </div>
</div>
